export default "/dist/files/rubrique_classements.926be049eaae0c19b752bfc8cb89267b.svg";